import { render } from "./UnboxBoxElement.vue?vue&type=template&id=c5d515c8&scoped=true"
import script from "./UnboxBoxElement.vue?vue&type=script&lang=js"
export * from "./UnboxBoxElement.vue?vue&type=script&lang=js"

import "./UnboxBoxElement.vue?vue&type=style&index=0&id=c5d515c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d515c8"]])

export default __exports__